import { gql } from "urql";
export const CreateUnifiedPriorityEntryMutation = gql `
    mutation CreateUnifiedPriorityEntry($input: UnifiedPriorityEntryInput!) {
        priorityEntries {
            createUnifiedPriorityEntry(input: $input) {
                priorityEntryId
                providers(matchTherapyCategory: true) {
                    userId
                    firstName
                    lastName
                    imageUrl
                }
                priorityAttribute {
                    priorityAttributeId
                    inquiredAt
                    priorityStatus {
                        priorityStatusId
                        name
                    }
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
                caregiver {
                    userId
                    firstName
                    lastName
                }
                patient {
                    patientId
                    firstName
                    lastName
                    dateOfBirth
                }
            }
        }
    }
`;
